import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1637646255092"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2057"
      width="32"
      height="32"
    >
      <path
        d="M245.034251 895.239428l383.063419-383.063419L240.001631 124.07997l0.070608-0.033769c-12.709463-13.137205-20.530592-31.024597-20.530592-50.731428 0-40.376593 32.736589-73.111135 73.115228-73.111135 19.705807 0 37.591153 7.819083 50.730405 20.528546l0.034792-0.035816 438.686251 438.681134-0.035816 0.034792c13.779841 13.281491 22.3838 31.915897 22.3838 52.586682 0 0.071631 0 0.106424 0 0.178055 0 0.072655 0 0.10847 0 0.144286 0 20.669762-8.603959 39.341007-22.3838 52.623521l0.035816 0.033769L343.426165 1003.661789l-0.180102-0.179079c-13.140275 12.565177-30.950919 20.313651-50.588165 20.313651-40.378639 0-73.115228-32.736589-73.115228-73.114205C219.544717 928.512229 229.432924 908.664182 245.034251 895.239428z"
        p-id="2058"
      ></path>
    </svg>
  )
}

const RightArrowIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon></Icon>
    </MorphReplace>
  )
}

// 默认参数
RightArrowIcon.defaultProps = {
  width: 10,
  height: 10,
  fill: '#bfbfbf',
}
// 参数类型
RightArrowIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default RightArrowIcon
